export enum FormAction {
    add = 'add',
    edit = 'edit',
    delete = 'delete',
    copy = 'copy',
    modify = 'edit-path',
}
